import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  MerchantSubmission,
  ValidatePartnerRoute,
  Callback,
  NotFound,
  Dashboard,
  RateReviewForm,
  RateReviewStatusPage
} from './components/index';
import { MessageProvider } from "./shared/providers/MessageProvider";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

/**
 * Wrapper component to extract dynamic partner from URL
 * Used for routes like: /some-partner
 */
const PartnerRouteWrapper = () => {
  const location = useLocation();
  const partner = location.pathname.slice(1); // Remove the leading '/' to get partner name
  return <ValidatePartnerRoute partner={partner} />;
};

const App = () => (
  <MessageProvider>
    <div className="App">
      <Routes>
        {/* Public Route: Home page (Merchant submission) */}
        <Route path="/" element={<MerchantSubmission />} />

        {/* Public Route: Rate Review Form */}
        <Route path="/rate-review" element={<RateReviewForm />} />

        {/* Public Route: Rate Review Status Page (with lead id) */}
        <Route path="/rate-review/:zohoId" element={<RateReviewStatusPage />} />

        {/* Public Route: Dynamic partner URLs */}
        <Route path="/:partner" element={<PartnerRouteWrapper />} />

        {/* Auth0 callback route after login */}
        <Route path="/auth/callback" element={<Callback />} />

        {/* Protected Route: Dashboard (requires login) */}
        <Route path="/dashboard/*" element={<Dashboard />} />

        {/* Fallback route for unmatched URLs */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  </MessageProvider>
);

export default App;
